export interface TruckModel {

  brand: string;
  model: string;
  imageUrl?: string;
  eGrossWeight?: number;
  eTare?: number;
  payload?: number;
  eTruckPrice?: number;
  battery?: number;
  chargingTime?: number;
  batteryTimeWarranty?: number;
  batteryDistanceWarranty?: number;


  // constructor(brand: string, model: string, imageUrl?: string, grossVehicleWeight?: number, tare?: number, battery?: number,
  //             chargingTime?: number, batteryTimeWarranty?: number, batteryDistanceWarranty?: number) {
  //   this.brand = brand;
  //   this.model = model;
  //   this.imageUrl = imageUrl;
  //   this.grossVehicleWeight = grossVehicleWeight;
  //   this.tare = tare;
  //   this.battery = battery;
  //   this.chargingTime = chargingTime;
  //   this.batteryTimeWarranty = batteryTimeWarranty;
  //   this.batteryDistanceWarranty = batteryDistanceWarranty;
  // }
}

export const truckModels: TruckModel[] = [
  {
    brand: 'JAC',
    model: '1063EV1',
    imageUrl: undefined,
    eGrossWeight: 6.49,
    eTare: 3.35,
    payload: 3.14,
    eTruckPrice: 49900,
    battery: 96.77,
    chargingTime: 3,
    batteryTimeWarranty: 8,
    batteryDistanceWarranty: 150000
  }, {
    brand: 'Farizon',
    model: 'E200X',
    imageUrl: undefined,
    eGrossWeight: 9,
    eTare: 3.4,
    payload: 5.6,
    eTruckPrice: 63250,
    battery: 106.95,
    chargingTime: 2.5,
    batteryTimeWarranty: 8,
    batteryDistanceWarranty: 150000
  }, {
    brand: 'Farizon',
    model: 'E200M',
    imageUrl: undefined,
    eGrossWeight: 5.9,
    eTare: 2.47,
    payload: 3.43,
    eTruckPrice: 52250,
    battery: 81.14,
    chargingTime: 2.5,
    batteryTimeWarranty: 8,
    batteryDistanceWarranty: 150000
  }, {
    brand: 'BYD',
    model: 'T4C',
    imageUrl: undefined,
    eGrossWeight: 4.3,
    eTare: 1.85,
    payload: 2.45,
    eTruckPrice: 68000,
    battery: 63.63,
    chargingTime: 1.7,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: 500000
  }, {
    brand: 'BYD',
    model: 'T45C01',
    imageUrl: undefined,
    eGrossWeight: 6.495,
    eTare: 2.8,
    payload: 3.695,
    eTruckPrice: 87000,
    battery: 99,
    chargingTime: 1.2,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: 500000
  }, {
    brand: 'BYD',
    model: 'T7BG',
    imageUrl: undefined,
    eGrossWeight: 11.8,
    eTare: 4.75,
    payload: 7.05,
    eTruckPrice: 131000,
    battery: 177.74,
    chargingTime: 2.5,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: 500000
  }, {
    brand: 'Dong Feng',
    model: 'e-Tuyi',
    imageUrl: undefined,
    eGrossWeight: 4.495,
    eTare: 2.495,
    payload: 2,
    eTruckPrice: 38805,
    battery: 55.7,
    chargingTime: 2,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: undefined
  }, {
    brand: 'Dong Feng',
    model: 'e-Shang',
    imageUrl: undefined,
    eGrossWeight: undefined,
    eTare: undefined,
    payload: 3.5,
    eTruckPrice: undefined,
    battery: 81.4,
    chargingTime: 2,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: undefined
  }, {
    brand: 'Dong Feng',
    model: 'e-Don',
    imageUrl: undefined,
    eGrossWeight: undefined,
    eTare: undefined,
    payload: undefined,
    eTruckPrice: undefined,
    battery: 98.04,
    chargingTime: undefined,
    batteryTimeWarranty: 5,
    batteryDistanceWarranty: undefined
  }
  // new TruckModel('BYD', 'T7BG')
];
